export enum InfodaycoUploadActions {
    UPLOAD_TUTORIAL = 'UPLOAD_TUTORIAL',
    UPLOAD_VIDEO_TUTORIAL = 'UPLOAD_VIDEO_TUTORIAL',
    UPLOAD_GUIDE = 'UPLOAD_GUIDE',
}
